import { useCallback } from 'react';

import { OperationEntity } from 'api/types/entity/operation';
import { useDialog } from 'libs/ui/Dialog/useDialog';

import { useLockAndUnlockOperation } from './useLockAndUnlockOperation';

export const useChangeStatusAction = (operation: OperationEntity | null) => {
  const { lockOperationIfPossible, unlockOperation } =
    useLockAndUnlockOperation(operation);

  const {
    isOpen: isOpenDialogChangeStatus,
    onClose: onCloseDialogChangeStatus,
    open: openDialogChangeStatus,
  } = useDialog();

  const onOpenDialogChangeStatus = useCallback(async () => {
    const isPossibleEdit = await lockOperationIfPossible?.();
    if (isPossibleEdit) {
      openDialogChangeStatus();
    }
  }, [lockOperationIfPossible, openDialogChangeStatus]);

  const handleCloseDialogChangeStatus = useCallback(() => {
    unlockOperation?.();
    onCloseDialogChangeStatus();
  }, [unlockOperation, onCloseDialogChangeStatus]);

  return {
    isOpenDialogChangeStatus,
    onCloseDialogChangeStatus: handleCloseDialogChangeStatus,
    onSuccessChangeStatus: onCloseDialogChangeStatus,
    onOpenDialogChangeStatus,
  };
};
